import { IS_TEST_MODE } from "../constants";
import type {
  FeedbackFieldDef,
  FeedbackFormSummary,
  FeedbackTargeting,
  FeedbackPlacement,
  SectionFormEntry,
  TriggerMode,
} from "./admin-feedback-api";
import { authHeaders } from "./api-client";

export async function getFeedbackForm(slug: string): Promise<FeedbackFormSummary | null> {
  if (IS_TEST_MODE) return null;
  const res = await fetch(`/api/website/feedback/forms/${encodeURIComponent(slug)}`, {
    headers: authHeaders(),
  });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("Failed to load feedback form.");
  const data = (await res.json()) as Partial<{ form: FeedbackFormSummary }>;
  if (!data.form) throw new Error("Feedback form response missing 'form' field.");
  return data.form;
}

export async function submitFeedbackResponse(
  formId: number,
  responses: Record<string, unknown>
): Promise<void> {
  if (IS_TEST_MODE) return;
  const res = await fetch("/api/website/feedback/responses", {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ formId, responses }),
  });
  if (!res.ok) throw new Error("Failed to submit feedback.");
}

export async function fetchTargetedFeedbackForms(
  pathname: string,
  signal?: AbortSignal
): Promise<{ forms: FeedbackFormSummary[]; sectionForms: SectionFormEntry[] }> {
  if (IS_TEST_MODE) return { forms: [], sectionForms: [] };
  const res = await fetch(
    `/api/website/feedback/targeted?pathname=${encodeURIComponent(pathname)}`,
    { headers: authHeaders(), signal }
  );
  if (!res.ok) throw new Error("Failed to load targeted feedback forms.");
  const data = (await res.json()) as Partial<{
    forms: FeedbackFormSummary[];
    sectionForms: SectionFormEntry[];
  }>;
  return {
    forms: Array.isArray(data.forms) ? data.forms : [],
    sectionForms: Array.isArray(data.sectionForms) ? data.sectionForms : [],
  };
}

export type {
  FeedbackFieldDef,
  FeedbackFormSummary,
  FeedbackTargeting,
  FeedbackPlacement,
  SectionFormEntry,
  TriggerMode,
};
